import CommonNaviIconMenu from '../../common/component/NaviIconMenu'

class NaviIconMenu extends CommonNaviIconMenu {
  constructor (props) {
    super(props)
    this.naviIconSetting = [
      {
        title: 'マイページ',
        url: '/company_admin/',
        iconClass: 'icon-home icon-large'
      },
      {
        title: '日常業務',
        url: '/company_admin/routine_task_home',
        iconClass: 'icon-table icon-large'
      },
      {
        title: '個人設定',
        url: '/company_admin/personal_setting_home',
        iconClass: 'icon-user icon-large'
      },
      {
        title: 'ｱﾝｹｰﾄ回答',
        url: '/company_admin/survey_answer',
        iconClass: 'icon-file icon-large'
      }
    ]
  }
}

export default NaviIconMenu



// WEBPACK FOOTER //
// ./src/company_admin/components/NaviIconMenu.js